import React from 'react';
import { Icon } from '../Icon';
import { Icons } from '@/assets';

export const TableV2 = ({
  headers = [],
  data = [],
  emptyMessage = 'No data available',
  minWidth,
  subEmptyMessage,
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-6">
        <Icon src={Icons.infoEmptyList} width={24} height={24} />
        <p className="text-inactive-text font-bold text-lg m-0 mt-4 mb-1">
          {emptyMessage}
        </p>
        {subEmptyMessage && (
          <p className=" text-inactive-text text-base m-0 mb-6">
            {subEmptyMessage}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="overflow-x-auto px-2 border-border-tertiary border border-solid rounded mb-8">
      <table
        className="w-full border-collapse"
        style={{ minWidth: minWidth || '800px' }}>
        <thead className="mb-4 h-42 rounded-t-md">
          <tr className="rounded-t-md">
            {headers.map((header, index) => (
              <th
                key={header.key || header || index}
                className={`px-1 text-center border-b border-solid border-r-0 border-border-tertiary border-t-0 border-l-0 font-bold text-11 text-primary-text relative ${
                  index === headers.length - 1 ? '' : ''
                }`}>
                {index !== headers.length - 1 && (
                  <div className="absolute right-0 top-2 bottom-2 w-px bg-gray-200"></div>
                )}
                {header.label || header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            return (
              <tr key={item.id || index} className="h-7 rounded-md mb-2">
                {item.cellData.map((cellContent, cellIndex) => {
                  return (
                    <td
                      key={cellIndex}
                      style={
                        index < data.length - 1
                          ? {}
                          : {
                              borderBottomWidth: 0,
                            }
                      }
                      className="relative text-center px-2 h-7 border-b border-border-tertiary border-solid border-r-0 border-t-0 border-l-0 align-middle text-xs text-gray-600 text-light">
                      {cellIndex < headers.length - 1 && (
                        <div className="absolute right-0 top-2 bottom-2 w-px bg-border-primary" />
                      )}
                      {cellContent}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
